import { useContext } from "react";
import { StepperContext } from "./context/StepperContext";
import CustomButtonFormStep from "../components/common-components/CustomButtonStepperForm";
import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

export interface IStepSubmitter {
  label: string;
  showPrevious: boolean;
  showNext: boolean;
  loading?: boolean;
}

export const StepSubmitter = (props: IStepSubmitter) => {
  const stepperState = useContext(StepperContext);
  const location = useLocation();
  const navigate = useNavigate();

  const isEditPassport = location.pathname.includes("edit-documents");
  const isEditW7 = location.pathname.includes("edit-w7");
  const isEditMode = isEditPassport || isEditW7;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        marginTop: "20px",
        gap: "20px",
        flexWrap: "wrap",
      }}
    >
      {isEditMode ? (
        <>
          <CustomButtonFormStep
            type="button"
            btnTitle="Back"
            handleClick={() => navigate(-1)}
            className="me-[10px]"
            bgColor="#EAF1FA"
            textColor={"#2977CC"}
          >
            Back
          </CustomButtonFormStep>

          <CustomButtonFormStep type="submit" loading={props.loading}>
            Update
          </CustomButtonFormStep>
        </>
      ) : (
        <>
          {props.showPrevious && (
            <CustomButtonFormStep
              btnTitle="Back"
              handleClick={() => {
                if (stepperState.setActiveStep) {
                  stepperState.setActiveStep(
                    stepperState.currentStepIdx - 1,
                    false
                  );
                }
              }}
              className="me-[10px]"
              bgColor="#EAF1FA"
              textColor={"#2977CC"}
            >
              Back
            </CustomButtonFormStep>
          )}
          {props.showNext && (
            <CustomButtonFormStep type={`submit`} loading={props.loading}>
              {props.label}
            </CustomButtonFormStep>
          )}
        </>
      )}
    </Box>
  );
};
